import React from "react";

export default (props) => (
  <div className="nav-tabs-custom flex d-flex flex-col">{props.children}</div>
);



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/template/tab/Tabs.jsx